import { LoaderFunction } from 'react-router-dom';

import { type ContentfulInstructorLedTraining } from 'src/graphql/queries/GetInstructorLedTraining';

import { getILTContefulContent } from './utils/getILTContenfulContent';

export interface ClassPageLoaderProps {
  courseId: string;
  contentfulILTData: ContentfulInstructorLedTraining;
}

export const classPageLoader: LoaderFunction = async ({ params }): Promise<ClassPageLoaderProps> => {
  const courseId = params.courseId ?? '';
  const preview = false;

  const contentfulILTData = await getILTContefulContent(courseId, preview);

  if (!contentfulILTData) {
    throw new Response('Instructor-led training not found', { status: 404 });
  }

  return {
    courseId,
    contentfulILTData,
  };
};
